import * as actionTypes from './actions';

export const initialState = {
  provinces: [],
  genders: [],
  weekday: [],
  career_topic_list: [],
  career_category_list: [],
  degree_list: [],
};

const metadataReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.METADATA:
      return {
        ...state,
        genders: action.genders,
        provinces: action.provinces,
        weekday: action.weekday,
        degree_list: action.degree,
        career_category_list: action.careers,
        career_topic_list: action.topics,
      };
    default:
      return state;
  }
};

export default metadataReducer;
